/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGithubEnterprise extends models.ServiceAccountNativeDetailsForGithubBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGithubEnterprise");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGithubEnterprise.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGithubEnterprise>): ServiceAccountNativeDetailsForGithubEnterprise {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGithubEnterprise(), model);
        ServiceAccountNativeDetailsForGithubEnterprise.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGithubEnterprise>): ServiceAccountNativeDetailsForGithubEnterprise {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGithubEnterprise.newInstance(<ServiceAccountNativeDetailsForGithubEnterprise> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGithubEnterprise) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGithubEnterprise.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGithubEnterprise): boolean {
        if (models.ServiceAccountNativeDetailsForGithubBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGithubEnterprise.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Organization Id. This is a required field
     */
    enterprise_id: string;

}
